import style from './ProjectItem.module.css';
import { useState } from 'react';

const ProjectItem = ({ data }) => {
  return (
    <div className={style.gradientContainer}>
      <div className={style.projectItem}>
        <h1>{data.title}</h1>
        <div className={style.descriptionContainer}>
          <p>{data.description}</p>
        </div>

        <div className={style.imgContainer}>
          <img src={data.image} alt={data.title} loading="lazy" />
        </div>

        <a href={data.link} target="_blank" rel="noopener noreferrer">
          <button className={style.website}>To Website</button>
        </a>
      </div>
    </div>
  );
};

export default ProjectItem;
